import { httpClient } from '../httpClient';
import {
  IVideoGeneration,
  CreateVideoGenerationRequest,
  UpdateVideoGenerationRequest,
  PaginatedResponse,
  VideoGenerationQuery,
  PaginationQuery
} from '@packages/global';

/**
 * 用户视频生成 API 模块
 * 处理用户视频生成管理操作
 */
export class VideoGenerationApi {
  /**
   * 获取用户视频生成分页列表（POST，强类型）
   */
  async videoGenerationPageList(queryData: PaginationQuery<VideoGenerationQuery>): Promise<PaginatedResponse<IVideoGeneration>> {
    return httpClient.post<PaginatedResponse<IVideoGeneration>>('/user/videoGenerations/page', queryData);
  }

  /**
   * 创建视频生成任务
   */
  async createVideoGeneration(data: CreateVideoGenerationRequest): Promise<IVideoGeneration> {
    return httpClient.post<IVideoGeneration>('/user/videoGenerations', data);
  }

  /**
   * 获取视频生成任务详情
   */
  async getVideoGeneration(id: string): Promise<IVideoGeneration> {
    return httpClient.get<IVideoGeneration>(`/user/videoGenerations/${id}`);
  }

  /**
   * 更新视频生成任务
   */
  async updateVideoGeneration(id: string, data: UpdateVideoGenerationRequest): Promise<IVideoGeneration> {
    return httpClient.put<IVideoGeneration>(`/user/videoGenerations/${id}`, data);
  }

  /**
   * 取消视频生成任务
   */
  async cancelVideoGeneration(id: string): Promise<void> {
    return httpClient.post<void>(`/user/videoGenerations/${id}/cancel`);
  }

  /**
   * 删除视频生成任务
   */
  async deleteVideoGeneration(id: string): Promise<void> {
    return httpClient.delete<void>(`/user/videoGenerations/${id}`);
  }
}

// 导出单例实例
export const videoGenerationApi = new VideoGenerationApi();